import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { Paper } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

const FooterNav = () => {
  // const [value, setValue] = useState("/");
  const navigate = useNavigate();
  const location = useLocation(); // Get current path
  const value = location.pathname; // Set value to current path
  const handleNavigation = (newValue) => {
    // setValue(newValue);
    navigate(newValue);
  };

  return (
    <Paper
      style={{
        position: "fixed",
        width: "25rem",
        bottom: 0,
      }}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => handleNavigation(newValue)}
        style={{ display: "flex" }}
      >
        <BottomNavigationAction
          value="/"
          label="Home"
          icon={
            <HomeIcon
              sx={{
                fontSize: 25,
                color: value === "/" ? "#f95959" : "#987108",
              }}
            />
          }
          sx={{
            "& .MuiBottomNavigationAction-label": {
              fontSize: 14,
              color: value === "/" ? "#f95959" : "#987108",
            },
          }}
        />

        <BottomNavigationAction
          value="/activity"
          label="VIP"
          icon={
            <PersonIcon
              sx={{
                fontSize: 25,
                color: value === "/activity" ? "#f95959" : "#987108",
              }}
            />
          }
          sx={{
            "& .MuiBottomNavigationAction-label": {
              fontSize: 14,
              color: value === "/activity" ? "#f95959" : "#987108",
            },
          }}
        />
        <BottomNavigationAction
          value="/profit"
          label="Profit"
          icon={
            <EventAvailableIcon
              sx={{
                fontSize: 25,
                color: value === "/profit" ? "#f95959" : "#987108",
              }}
            />
          }
          sx={{
            "& .MuiBottomNavigationAction-label": {
              fontSize: 14,
              color: value === "/profit" ? "#f95959" : "#987108",
            },
          }}
        />

        <BottomNavigationAction
          value="/fund"
          label="Wallet"
          icon={
            <AccountBalanceWalletIcon
              sx={{
                fontSize: 25,
                color: value === "/fund" ? "#f95959" : "#987108",
              }}
            />
          }
          sx={{
            "& .MuiBottomNavigationAction-label": {
              fontSize: 14,
              color: value === "/fund" ? "#f95959" : "#987108",
            },
          }}
        />

        <BottomNavigationAction
          value="/mian"
          label="My"
          icon={
            <PersonIcon
              sx={{
                fontSize: 25,
                color: value === "/mian" ? "#f95959" : "#987108",
              }}
            />
          }
          sx={{
            "& .MuiBottomNavigationAction-label": {
              fontSize: 14,
              color: value === "/mian" ? "#f95959" : "#987108",
            },
          }}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default FooterNav;
